import { jsx } from 'react/jsx-runtime';
import React, { useMemo } from 'react';
import { css } from 'styled-components';
import { isMobile } from '../../helpers/browsers.esm.js';
import { ExtendedTooltip } from './ExtendedTooltip.esm.js';
import { TOOLTIP_BACKGROUND_COLOR_VAR, TOOLTIP_COLOR_VAR, TOOLTIP_BORDER_RADIUS_VAR } from './Tooltip.consts.esm.js';
import { isTooltipAlignment } from './tooltip.helpers.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    &:before,\n    &:after {\n      ",
        ": 100%;\n    }\n\n    &:before {\n      ",
        ": -",
        "px;\n      ",
        ": ",
        ";\n      ",
        ": var(",
        ", ",
        ");\n    }\n\n    &:after {\n      transform: translateX(",
        "%);\n      margin-left: ",
        "px;\n    }\n\n    &:hover {\n      &:before {\n        transform: translateY(",
        "px);\n      }\n      &:after {\n        transform: translateX(",
        "%)\n          translateY(",
        "px);\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    position: relative;\n\n    &:before,\n    &:after {\n      position: absolute;\n      transform: translate3d(0, 0, 0);\n      visibility: hidden;\n      opacity: 0;\n      z-index: 1000000;\n      pointer-events: none;\n      transition: 0.3s ease;\n    }\n\n    &:before {\n      content: '';\n      position: absolute;\n      background: transparent;\n      border: ",
        "px solid transparent;\n      z-index: 1000001;\n      left: calc(50% - ",
        "px);\n    }\n\n    &:after {\n      background: ",
        ";\n      background: var(",
        ", ",
        ");\n      color: ",
        ";\n      color: var(",
        ", ",
        ");\n      border-radius: ",
        "px;\n      border-radius: var(",
        ", ",
        "px);\n      ",
        "\n      left: 50%;\n    }\n\n    :hover {\n      &:before,\n      &:after {\n        visibility: visible;\n        opacity: 1;\n      }\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n         {\n          *[data-tooltip]:not([data-tooltip='']) {\n            ",
        "\n\n            &:after {\n              content: attr(data-tooltip);\n            }\n\n            &[data-tooltip-alignment='top-center'] {\n              ",
        "\n            }\n            &[data-tooltip-alignment='bottom-center'] {\n              ",
        "\n            }\n            &[data-tooltip-alignment='top-right'] {\n              ",
        "\n            }\n            &[data-tooltip-alignment='top-left'] {\n              ",
        "\n            }\n            &[data-tooltip-alignment='bottom-right'] {\n              ",
        "\n            }\n            &[data-tooltip-alignment='bottom-left'],\n            &:not([data-tooltip-alignment]) {\n              ",
        "\n            }\n          }\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var tooltipAlignmentMixin = function(param) {
    var alignment = param.alignment, tooltip = param.tooltip, colors = param.colors;
    var _alignment_split = _sliced_to_array(alignment.split("-"), 2), y = _alignment_split[0], x = _alignment_split[1];
    var oppositeY = y === "top" ? "bottom" : "top";
    var marginProp = "margin-".concat(oppositeY);
    var borderColorProp = "border-".concat(y, "-color");
    var _tooltip_triangleSize = tooltip.triangleSize, triangleSize = _tooltip_triangleSize === void 0 ? 0 : _tooltip_triangleSize, _tooltip_margin = tooltip.margin, margin = _tooltip_margin === void 0 ? 0 : _tooltip_margin, backgroundColor = tooltip.backgroundColorName;
    return css(_templateObject(), oppositeY, marginProp, triangleSize * 2, borderColorProp, colors[backgroundColor], borderColorProp, TOOLTIP_BACKGROUND_COLOR_VAR, colors[backgroundColor], x === "left" ? -100 : x === "center" ? -50 : 0, triangleSize * (x === "left" ? 2 : x === "center" ? 0 : -2), y === "top" ? -margin : margin, x === "left" ? -100 : x === "center" ? -50 : 0, y === "top" ? -margin : margin);
};
var tooltipMixin = function(param) {
    var tooltip = param.tooltip, colors = param.colors;
    var _tooltip_triangleSize = tooltip.triangleSize, triangleSize = _tooltip_triangleSize === void 0 ? 0 : _tooltip_triangleSize, _tooltip_borderRadius = tooltip.borderRadius, borderRadius = _tooltip_borderRadius === void 0 ? 0 : _tooltip_borderRadius, tooltipStyling = tooltip.tooltipStyling, backgroundColor = tooltip.backgroundColorName, color = tooltip.colorName;
    return css(_templateObject1(), triangleSize, triangleSize, colors[backgroundColor], TOOLTIP_BACKGROUND_COLOR_VAR, colors[backgroundColor], colors[color], TOOLTIP_COLOR_VAR, colors[color], borderRadius, TOOLTIP_BORDER_RADIUS_VAR, borderRadius, tooltipStyling);
};
var Tooltip = function(props) {
    var text = props.text, _props_content = props.content, content = _props_content === void 0 ? text : _props_content, tooltipBorderRadius = props.tooltipBorderRadius, alignment = props.alignment, children = props.children, tooltipBackgroundColor = props.tooltipBackgroundColor, tooltipColor = props.tooltipColor, style = props.style, rest = _object_without_properties(props, [
        "text",
        "content",
        "tooltipBorderRadius",
        "alignment",
        "children",
        "tooltipBackgroundColor",
        "tooltipColor",
        "style"
    ]);
    var borderRadius = useMemo(function() {
        return tooltipBorderRadius != null ? "".concat(tooltipBorderRadius, "px") : tooltipBorderRadius;
    }, [
        tooltipBorderRadius
    ]);
    if (content == null) {
        return null;
    }
    if (typeof content === "string" && (!alignment || isTooltipAlignment(alignment))) {
        var _obj;
        return /*#__PURE__*/ React.cloneElement(children, _object_spread_props(_object_spread({}, rest), {
            "data-tooltip": content,
            "data-tooltip-alignment": alignment !== null && alignment !== void 0 ? alignment : "bottom-left",
            style: _object_spread((_obj = {}, _define_property(_obj, TOOLTIP_BACKGROUND_COLOR_VAR, tooltipBackgroundColor), _define_property(_obj, TOOLTIP_COLOR_VAR, tooltipColor), _define_property(_obj, TOOLTIP_BORDER_RADIUS_VAR, borderRadius), _obj), style)
        }));
    }
    var _obj1;
    return /*#__PURE__*/ jsx(ExtendedTooltip, _object_spread_props(_object_spread({}, rest), {
        content: content,
        placement: alignment,
        style: _object_spread((_obj1 = {}, _define_property(_obj1, TOOLTIP_BACKGROUND_COLOR_VAR, tooltipBackgroundColor), _define_property(_obj1, TOOLTIP_COLOR_VAR, tooltipColor), _define_property(_obj1, TOOLTIP_BORDER_RADIUS_VAR, borderRadius), _obj1), style),
        children: children
    }));
};
var tooltipGlobalStyle = function(tooltip, colors) {
    return isMobile() ? "" : css(_templateObject2(), tooltipMixin({
        tooltip: tooltip,
        colors: colors
    }), tooltipAlignmentMixin({
        alignment: "top-center",
        tooltip: tooltip,
        colors: colors
    }), tooltipAlignmentMixin({
        alignment: "bottom-center",
        tooltip: tooltip,
        colors: colors
    }), tooltipAlignmentMixin({
        alignment: "top-right",
        tooltip: tooltip,
        colors: colors
    }), tooltipAlignmentMixin({
        alignment: "top-left",
        tooltip: tooltip,
        colors: colors
    }), tooltipAlignmentMixin({
        alignment: "bottom-right",
        tooltip: tooltip,
        colors: colors
    }), tooltipAlignmentMixin({
        alignment: "bottom-left",
        tooltip: tooltip,
        colors: colors
    }));
};

export { Tooltip, tooltipGlobalStyle };
